import React from 'react';
import { Modal, BodyText, Button, HeadingText } from '@paypalcorp/pp-react';
import { StyleSheet, css } from 'aphrodite';
import PropTypes from 'prop-types';

const styles = StyleSheet.create({
	modalContent: {
		maxWidth: 600,
		margin: '0 auto'
	},
	okButton: {
		marginTop: 36
	},
	msgMargin: {
		marginTop: '24px'
	}
});

export default function DonateGiftAidHowItWorksOverlay(props) {
	const {
		content
	} = props;

	return (
		<Modal
			className="giftaid-howitworks-overpanel"
			overpanel
			title=""
			isOpen={props.isOpen}
			onClose={props.closeOverlay}
			hideLogo
			closeOnBackgroundClick={true}
		>
			<div className="modal-body" id="giftaiditModal">
				<div className="">
					<div className={`${css(styles.modalContent)} modal-content`} >
						<div className="ppvx_row">
							<div className="ppvx_col-12 text-center">
								<HeadingText size="lg">{content.howitworks}</HeadingText>
							</div>
						</div>
						<div className="ppvx_row">
							<div className="ppvx_col-12">
								<BodyText className={css(styles.msgMargin)}>{content.modalp1}</BodyText>
							</div>
						</div>
						<div className="ppvx_row">
							<div className="ppvx_col-12">
								<BodyText className={css(styles.msgMargin)}>{content.modalp2}</BodyText>
							</div>
						</div>
						<div className="ppvx_row">
							<div className="ppvx_col-12">
								<BodyText className={css(styles.msgMargin)}>{content.modalp3}</BodyText>
							</div>
						</div>
						<div className="ppvx_row">
							<div className="ppvx_col-12">
								<BodyText className={css(styles.msgMargin)}>{content.modalp4}</BodyText>
							</div>
						</div>

						<div className="ppvx_row">
							<div className="ppvx_col-12">
								<div className={`${css(styles.okButton)} text-center`}>
									<Button className="btn-wide" onClick={props.closeOverlay}>{content.ok}</Button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
}

DonateGiftAidHowItWorksOverlay.propTypes = {
	content: PropTypes.object,
	isOpen: PropTypes.bool,
	closeOverlay: PropTypes.func
}
